import {AfterViewInit, Component, OnInit, ViewChild ,ViewContainerRef, Directive} from '@angular/core';
import { S3Service,CognitoCallback } from '../../service/s3.service';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { UserLoginService } from "../../service/user-login.service";
import {CognitoUtilService, LoggedInCallback, Callback } from "../../service/cognito-util.service";
import {UserParametersService} from "../../service/user-parameters.service";
import {AwsUtilService} from "../../service/aws-util.service";
import { Contact } from '../../shared/contact'
import { MatDialog, MatDialogRef, MatListModule } from '@angular/material';
import { AddContactDialogComponent } from './addContactDialog.component';
import { Router } from "@angular/router";
import { AuthService } from '../../service/auth.service';
import { DialogsService } from '../../service/dialogs.service';
//@Directive({selector: 'p-editor'})


@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.css']
})
export class ContactsComponent implements OnInit  {
  contacts:Contact[] = [];
  board:Contact[] = [];
  
  loading = false;
  userGroup: string = '';
//  @ViewChild("p-editor")

  name:string = "yhteyshenkilot.json";
  constructor( public s3Service: S3Service,public userService: UserLoginService, private viewContainerRef: ViewContainerRef,
    private authService: AuthService, public userParams: UserParametersService, 
    public cognitoUtil: CognitoUtilService,  public awsUtil: AwsUtilService, private dialogsService: DialogsService,
    public dialog: MatDialog ) { 
      

  }
  /* public role: string,
  public firstName: string,
  public lastName: string,
  public phoneNumber: number,
  public email: string,
  public address: string,
  public town: string,
  public postalCode: number, */

  ngOnInit() {
    console.log('ContactsComponent ngOnInit()');
    this.authService.userGroup.subscribe((userGroup) => {
      this.userGroup = userGroup;
      console.log('ContactsComponent userGroup: ',this.userGroup);
    });
    this.contacts = [
     {"role":"Puheenjohtaja", "firstName": "Tapio", "lastName": "Kalliomäki", 
      "phoneNumber":"0405153683", "email": "tapio.kalliomaki61@gmail.com","address":"Koppelontie 343", 
     "town": "Isojoki", "postalCode": 64900},
     {"role":"Varapuheenjohtaja", "firstName": "Tuomas", "lastName": "Ahola", 
     "phoneNumber":"0400480833", "email": "tuomasilmariahola@gmail.com","address":"Heikkilänjoentie 291", 
    "town": "Heikkilänjoki", "postalCode": 64840},
     {"role":"Sihteeri", "firstName": "Marko", "lastName": "Järnstedt", 
     "phoneNumber":"0408339362", "email": "marko.jarnstedt@gmail.com","address":"Rantakodontie 10", 
    "town": "Sastamala", "postalCode": 38460},
    {"role":"Rahastonhoitaja", "firstName": "Tapio", "lastName": "Uusitalo", 
     "phoneNumber":"0400867564", "email": "tapiouusitalo359@gmail.com","address":"Honkajoentie 359", 
    "town": "Isojoki", "postalCode": 64900}
    ];
    this.board = [
      {"role":"Jäsen", "firstName": "Juho", "lastName": "Koivisto", 
      "phoneNumber":"0400260331", "email": "juhoKoivisto97@gmail.com","address":"Koppelontie 375", 
     "town": "Isojoki", "postalCode": 64900},
     {"role":"Jäsen", "firstName": "Hannu", "lastName": "Jänisoja", 
     "phoneNumber":"0405525081", "email": "","address":"Etelätie 11", 
    "town": "Isojoki", "postalCode": 64900},
     {"role":"Jäsen", "firstName": "Aki", "lastName": "Ykspetäjä", 
     "phoneNumber":"0440409382", "email": "aki.ykspetaja@porinkonehuolto.fi","address":"Järvikyläntie 25", 
    "town": "Pori", "postalCode": 28220},
    {"role":"Jäsen", "firstName": "Kari", "lastName": "Kenola", 
     "phoneNumber":"0500900677", "email": "","address":"Koppelontie 46", 
    "town": "Isojoki", "postalCode": 64900},
    {"role":"Jäsen", "firstName": "Tapio", "lastName": "Uusitalo", 
     "phoneNumber":"0400867564", "email": "tapiouusitalo359@gmail.com","address":"Honkajoentie 359", 
    "town": "Isojoki", "postalCode": 64900}
    ]

   // this.authService.initAuth();
  }

}
//public upload (content, name, callback: uploadCallBack){


// WEBPACK FOOTER //
// ./src/app/public/contacts/contacts.component.ts